import { get } from '../tools/http';

const DICT_IN_LOADING = {};

export default {
    state: {
        dictionary: {},
        competence: [],
        allCompetence: [],
        genders: [
            {
                is_man: 'true',
                value: 'Мужской',
            },
            {
                is_man: 'false',
                value: 'Женский',
            },
        ],
        localDictionaries: {
            gender: [
                { value: true, text: 'Мужской' },
                { value: false, text: 'Женский' },
            ],
        },
    },
    mutations: {
        setDictionary: (state, types) => {
            if (types) {
                state.dictionary = types.reduce((acc, type) => {
                    acc[type] = state.dictionary[type] ? state.dictionary[type] : [];
                    return acc;
                }, {});
            }
        },
        setCompetence: (state, competenceList) => {
          state.competence = competenceList;
        },
        setAllCompetence: (state, competenceList) => {
          state.allCompetence = competenceList;
        },
        setDictionaryItems: (state, { type, items }) => {
            state.dictionary = { ...state.dictionary, [type]: items };
        },
    },
    actions: {
        loadDictionary: async ctx => {
            let items = await get('data', 'catalog/get-types');
            ctx.commit('setDictionary', items);
        },
        loadProgressCompetence: async (ctx) => {
          const items = await get('progress', 'api/v1/competence?fields[]=id&fields[]=name');
          ctx.commit('setCompetence', items);
        },
        loadAllProgressCompetence: async (ctx) => {
          const items = await get('progress', 'api/v1/competence?fields[]=id&fields[]=name&filter[isPublished]=all');
          ctx.commit('setAllCompetence', items);
        },
        loadDictionaryItems: async (ctx, type, withDeleted = false, withMeta = false) => {
            if (DICT_IN_LOADING[type]) {
                await new Promise(resolve => {
                    const wait = () => setTimeout(
                        () => DICT_IN_LOADING[type] ? wait() : resolve(),
                        10
                    );
                    wait();
                });
                return;
            }

            DICT_IN_LOADING[type] = true;

            try {
                const query = [];

                if (withDeleted) {
                    query.push('is_deleted=true');
                }

                if (withMeta) {
                    query.push('with_meta=true');
                }

                const items = await get('data', `catalog/get/${type}?${query.join('&')}`);

                ctx.commit('setDictionaryItems', {
                    type,
                    items,
                });

                DICT_IN_LOADING[type] = false;
            } catch (e) {
                console.error(e);
                DICT_IN_LOADING[type] = false;
                await ctx.dispatch('loadDictionaryItems', type, withDeleted, withMeta);
            }
        },
        getDictionaryItemById: async (ctx, id) => {
            return await get('data', `element/${id}`);
        },
        dictionaryAutocomplete: async (ctx, { type, search }) => {
            if (!search || search.length <= 2) {
                return [];
            }
            return await get(
                'data',
                `catalog/search/${type}?q=${encodeURIComponent(search)}`
            );
        },
    },
    getters: {
        dictionaryByType: state => type => {
            if (state.dictionary[type] && state.dictionary[type].length) {
                return state.dictionary[type];
            } else if (state.localDictionaries[type] && state.localDictionaries[type].length) {
                return state.localDictionaries[type];
            }
            return [];
        },
        getCompetenceList: state => {
          return state.competence;
        },
        getAllCompetenceList: state => {
          return state.allCompetence;
        },
        getGendersDictionary: state => {
            return state.genders;
        },
    },
};
